/**
 * Slides component.
 * @module components/Frontpage/Slides
 */

import React from 'react';
import { UniversalLink, Image } from '@plone/volto/components';
import { searchContent } from '@plone/volto/actions';
import { flattenToAppURL } from '@plone/volto/helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightLong } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import { Carousel } from '../../';

import { Container, Button } from 'semantic-ui-react';

const SLIDE_OPTIONS = {
    loop: true,
    autoplay: false,
    dots: false,
    buttons: true,
    customClass: 'main-slider',
    stopOnMouseEnter: true
}


const ItemView = props => {
    const { item } = props

    return (
        <article className=" slideItem " key={item['@id']}>
            <Image
                item={item}
                className="slideItem__image"
                alt=""
                sizes="100vw"
            />
            <Container className="slideItem__text">
                <h3 className="slideItem__title fsc-h1" >
                    {item?.getRemoteUrl ? (
                        <UniversalLink href={item.getRemoteUrl} className="slideItem__link stretched-link">{item.title}</UniversalLink>
                    ) : (
                        <>{item.title}</>
                    )}
                </h3>
                {item?.description ? (
                    <p className="slideItem__desc fsc-h5">
                        {item.description}
                    </p>
                ) : null}
                {item?.getRemoteUrl ? (
                    <div className='mt-4 mt-lg-3 pt-lg-3'>
                        <span className='slideItem__button ui button primary' aria-hidden="true">
                            {item?.button_text ? (<>{item.button_text}</>) : (<FormattedMessage id="More info" defaultMessage="More info" />)}
                        </span>
                    </div>
                ) : null}
            </Container>
        </article>
    )

};

const SliderListing = ({ items, linkTitle, linkHref, isEditMode, blockTitle }) => {
    let href = (linkHref?.[0]?.['@id']) || '';
    let link = href ? flattenToAppURL(href) : '';

    return (
        <section className={"slides slidesWrapper " + (!isEditMode ? ' full-width' : ' slides--isEditMode')}>
            <h2 className="visually-hidden"><FormattedMessage id="featured" defaultMessage="Featured" /></h2>
            {items && <Carousel slides={items.slice(0, 8)} delayTime={6500} ItemView={ItemView} options={{...SLIDE_OPTIONS, showCounter: true}} />}
        </section>
    );

};

export default SliderListing;